import styled, { css } from 'styled-components';

export const NoMarginWrapper = styled.div<{ $noMargin?: boolean }>`
  .ant-form-item {
    ${({ $noMargin }) =>
      $noMargin &&
      css`
        margin-bottom: 0;
      `}
  }
`;
